// extracted by mini-css-extract-plugin
export var chevron = "_gi-2";
export var dropdownItems = "_gi-0";
export var item = "_gi-1";